import React from "react"
import { useTranslation } from "react-i18next"

import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"
import { ChipList } from "shared/ui/chip-list/ChipList"

import {
  ProductFilterItem,
  ProductFilterType
} from "../../types/ProductFilterType"
import { ProductFilterChip } from "./ProductFilterChip"

type ValueByFilterType<FilterType extends ProductFilterType> =
  FilterType extends typeof ProductFilterType.BUILDING_TYPE
    ? BuildingType
    : FilterType extends typeof ProductFilterType.ROOM_TYPE
    ? RoomType
    : string

export type OnRemoveProductFilter<
  FilterType extends ProductFilterType = ProductFilterType
> = (filterType: FilterType, value: ValueByFilterType<FilterType>) => void

export interface ProductFilterChipListViewModel {
  chips: ProductFilterItem[]
  onRemove: OnRemoveProductFilter
}

export interface ProductFilterChipListViewProps
  extends ProductFilterChipListViewModel {}

export const ProductFilterChipListView = React.memo(
  ({ chips, onRemove }: ProductFilterChipListViewProps) => {
    const { t } = useTranslation()

    return (
      <ChipList.List
        aria-label={t("Filter.ActiveFilters")}
        className="product-filter-chip-list"
      >
        {chips.map(chip => (
          <ProductFilterChip key={chip.key} chip={chip} onRemove={onRemove} />
        ))}
      </ChipList.List>
    )
  }
)

ProductFilterChipListView.displayName = "ProductFilterChipListView"
